import { makeStyles } from '@mui/styles';
import React, { useEffect, useRef } from 'react';

const useStyles = makeStyles({
  mainContainer: {
    height: '100vh',
  },
});

const DocumentCollaboration = ({ formAction, accessToken, accessTokenTtl }) => {
  const classes = useStyles();
  const formRef = useRef();
  const frameHolderRef = useRef();

  useEffect(() => {
    if (formAction) {
      const frameholder = frameHolderRef.current;
      const officeFrame = document.createElement('iframe');
      officeFrame.name = 'office_frame';
      officeFrame.id = 'office_frame';
      // The title should be set for accessibility
      officeFrame.title = 'Office Online Frame';
      officeFrame.height = '100%';
      officeFrame.width = '100%';
      officeFrame.scrolling = 'auto';
      officeFrame.frameborder = '0';
      // This attribute allows true fullscreen mode in slideshow view
      // when using PowerPoint Online's 'view' action.
      officeFrame.setAttribute('allowfullscreen', 'true');
      // The sandbox attribute is needed to allow automatic redirection to the O365 sign-in page in the business user flow
      officeFrame.setAttribute(
        'sandbox',
        'allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox'
      );
      frameholder.appendChild(officeFrame);
      formRef.current.submit();
    }
  }, [formAction]);

  return (
    <>
      <form
        ref={formRef}
        id="office_form"
        name="office_form"
        target="office_frame"
        action={formAction}
        method="post"
      >
        <input id="access_token" name="access_token" value={accessToken} type="hidden" />
        <input id="access_token_ttl" name="access_token_ttl" value={accessTokenTtl} type="hidden" />
      </form>

      <div ref={frameHolderRef} id="frameholder" className={classes.mainContainer} />
    </>
  );
};

export default DocumentCollaboration;
